import B2C_StudentService from '@/components/b2c_student/b2c_student'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/b2c_student/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div>
      <B2C_StudentService />
    </div>
  )
}
